import type { AlertProps } from '@mui/material'
import type { ReactNode } from 'react'
import { createContext, useContext } from 'react'

export type SnackbarProps = {
  severity: AlertProps['color']
  message: ReactNode
  disableAutoClose?: boolean
}

export type SnackbarContextProps = {
  showSnackbar: (snackbarOptions: SnackbarProps) => void
  closeSnackbar: () => void
}

const SnackbarContext = createContext<SnackbarContextProps>({
  showSnackbar: () => undefined,
  closeSnackbar: () => undefined,
})

export const useSnackbar = (): SnackbarContextProps => {
  return useContext(SnackbarContext)
}

export default SnackbarContext
